import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersist({
  storage: window.localStorage // 可选存储方式
})

export default new Vuex.Store({
  state: {
    // PKPM版本
    cloudAppVersion: 'PKPM02',
    // 云盘用户Id
    cloudUserId: '',

    enterPriseList: [], // 公司名list
    enterPriseId: '', // 企业成员当前所属企业Id
    enterPriseName: '个人', // 企业成员当前所属企业
    passportId: null,
    selectOptions: [],
    enterPriseVerifystatus: '', // 企业当前认证状态
    goodsMessage: '',
    processList: {},
    isSuperAdminUser:true,//是否是子管理员登录，默认不是子管理员，是超级管理员
  },
  mutations: {
    setCloudVersion (state, version) {
      state.cloudAppVersion = version
    },
    setCloudUserId (state, id) {
      state.cloudUserId = id
    },
    setEnterPriseList (state, list) {
      state.enterPriseList = list
    },
    setPassportId (state, id) {
      state.passportId = id
    },
    setCurrentCompanyId (state, id) { // 当前公司名
      state.enterPriseId = id
    },
    setCurrentCompany (state, payload) { // 当前公司名
      state.enterPriseName = payload
    },
    setCurrentVerifystatus (state, payload) {
      state.enterPriseVerifystatus = payload
    },
    setGoodsMessage(state,payload){
      state.goodsMessage=''
      state.goodsMessage=payload
    },
    setProcessList(state, list) {
      state.processList = list
    },
    setCompanyLoginRole(state,payload){
      state.isSuperAdminUser=payload
    }
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js